import * as React from 'react';
import LinearProgress, { linearProgressClasses } from '@mui/material/LinearProgress';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import { CacheProvider } from '@emotion/react';
import { alpha, ThemeProvider, useMediaQuery, useTheme } from '@mui/material';
import { styled } from '@mui/material/styles';
import { cacheLtr } from '../GeneralUtils';

const StyledLinearProgress = styled(LinearProgress)(({ theme }) => ({
  height: 6,
  borderRadius: 2,
  background: alpha(theme.palette.text.primary, 0.1),
  [`& .${linearProgressClasses.bar}`]: {
    borderRadius: 2,
    backgroundColor: theme.palette.primary.main,
  },
}));

const LinearProgressWithLabel = (props) => {
  const { value, total } = props;
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down('md'));

  let percent = Math.round((value / total) * 100);
  if (percent > 100) {
    percent = 100;
  }

  return (
    <CacheProvider value={cacheLtr}>
      <ThemeProvider theme={{ ...theme, direction: 'ltr' }}>
        <Box
          sx={{
            width: '100%',
            color: 'text.primary',
            marginInline: isSmallScreen ? '2px' : '8px',
            marginTop: '4px',
            direction: 'ltr',
            display: 'flex',
            alignItems: 'center',
            flexDirection: 'column',
          }}>
          <Box sx={{ width: '100%' }}>
            <StyledLinearProgress variant="determinate" value={percent} />
          </Box>
          <Box sx={{ minWidth: 35 }}>
            <Typography
              variant="body2"
              sx={{
                fontWeight: 'bold',
                fontSize: '0.8rem',
                fontVariantNumeric: 'tabular-nums',
                color: value <= total ? 'text.primary' : 'error.main',
              }}>
              {value}
              <Box
                sx={{
                  marginInline: '2px',
                  display: 'inline',
                }}>
                /
              </Box>
              {total}
            </Typography>
          </Box>
        </Box>
      </ThemeProvider>
    </CacheProvider>
  );
};

export default LinearProgressWithLabel;
